import React, { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';

const suggestions = [
  'How has cloud adoption changed from 2023 to 2025?',
  'Most popular programming languages in 2024',
  'Participation rate per region, for each year'
];

const moreSuggestions = [
  'Which programming languages have climbed the participation-rank leaderboard the most in the last three survey cycles?',
  'Most popular programming languages in 2024',
  'Bar chart comparing the top 5 programming languages by participation rank in the latest survey.',
  'How have database preferences (PostgreSQL, MySQL, MongoDB, etc.) evolved?',
  'How has Nortal\'s overall cloud adoption rate evolved year-over-year?',
  'Generate a heatmap showing the percentage of engineers using technologies they do like, with rows as regions and columns as programming languages. Limit to 5 programing languages',
  'Participation rate per region, for each year. Single bar chart, vertical text of % on bars, horizontal lines of average % for each year'
];

export const SuggestionsSection = ({ onSuggestionClick }) => {
  return (
    <div className='mb-6 flex items-center justify-between w-full pt-6'>
      <div className='flex flex-wrap gap-4'>
        {suggestions.map((value) => (
          <button
            key={value}
            onClick={() => onSuggestionClick(value)}
            className='bg-white text-gray-600 px-4 py-2 rounded-full border border-gray-300 hover:bg-gray-50 transition'
          >
            {value}
          </button>
        ))}
      </div>

      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className="text-gray-500 hover:text-gray-700 transition ml-4 focus:outline-none"
            >
              See more
            </Popover.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute right-0 mt-2 w-96 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
                <div className="p-3">
                  <h3 className="text-sm font-medium text-gray-700 mb-2">More suggestions</h3>
                  <div className="flex flex-col space-y-2">
                    {moreSuggestions.map((suggestion) => (
                      <Popover.Button
                        key={suggestion}
                        as="button"
                        onClick={() => onSuggestionClick(suggestion)}
                        className="text-left text-gray-600 hover:bg-gray-50 p-2 rounded text-sm transition"
                      >
                        {suggestion}
                      </Popover.Button>
                    ))}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}; 